import React, {useContext, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {ResetStatus as resetStatus} from '../../../.../../../../../redux/reducers/EnableFramework/FilterGroup';
import SearchRuleGroupContainer from './SearchFilterGroupContainer';
import {ThemeContext} from '../../../.../../../../../themes/ThemeProvider';


function SearchFilterGroup({
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setSelectedFilterGroupCode,
  setFilterGroupCode,
  setSelectedRows,
  selectedRows,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetStatus());
  }, []);
  return (
    <>
      <div className={classes.dialoguecardStyles} elevation={0}>
        <SearchRuleGroupContainer
          setTabValue={setTabValue}
          handleClose={handleClose}
          setSelectedFilterGroupCode={setSelectedFilterGroupCode}
          setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
          setFilterGroupCode={setFilterGroupCode}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
        />
      </div>
    </>
  );
}

export default SearchFilterGroup;
